var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 43.55 33.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outline_Old_Icons",
    "data-name": "Outline Old Icons"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.28,5.55a3.26,3.26,0,0,0-1.46,6.19L32,18.29l-9.21-10a4.2,4.2,0,1,0-2,0l-9.21,10L4.83,11.69a3.25,3.25,0,1,0-1.56.41,2.23,2.23,0,0,0,.27,0L7.26,26.83H7a3.28,3.28,0,1,0,0,6.55h29.6a3.28,3.28,0,0,0,0-6.55H36.3l3.83-14.74h.15a3.28,3.28,0,0,0,0-6.55ZM1,8.83A2.28,2.28,0,1,1,3.89,11a.45.45,0,0,0-.23,0h0a2.33,2.33,0,0,1-.38,0A2.27,2.27,0,0,1,1,8.83ZM18.58,4.2a3.2,3.2,0,1,1,3.2,3.2A3.2,3.2,0,0,1,18.58,4.2ZM38.83,30.1a2.14,2.14,0,0,1-2.25,2.28H7a2.28,2.28,0,1,1,0-4.55h29.6A2.14,2.14,0,0,1,38.83,30.1Zm-3.56-3.27h-27L4.83,13.08l6.42,6.28a.6.6,0,0,0,.36.14.48.48,0,0,0,.36-.16L21.78,8.67l9.8,10.67a.48.48,0,0,0,.36.16.5.5,0,0,0,.36-.14l6.53-6.24Zm5-15.73a2.28,2.28,0,1,1,2.27-2.27A2.28,2.28,0,0,1,40.28,11.1Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.ce70e85f959d96c04dc09944d0f941b5.svg";
export { ForwardRef as ReactComponent };